





















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import InvestmentAccountTypeFeeDetails from "@/shared/components/investments/drivewealth/InvestmentAccountTypeFeeDetails.vue";
import {
  DrivewealthAccountSummary,
  InvestmentManagementType
} from "@/shared/types";

@Component({
  components: {
    InvestmentAccountTypeFeeDetails
  }
})
export default class InvestmentAccountTypeLink extends Vue {
  formatCurrency = formatCurrency;

  @Prop()
  account: DrivewealthAccountSummary;

  @Prop()
  accountType: InvestmentManagementType;

  @Prop()
  isHsaBank: boolean;

  @Prop()
  accountTypeName: string;

  @Prop()
  accountTypeDescription: string;

  @Prop()
  icon: string;

  get hasAccount () {
    return this.account !== undefined;
  }

  get formattedDateNow () {
    return moment().format("MMM DD");
  }

  get anchorClasses () {
    return {
      "d-flex": true,
      "align-items-center": true,
      "jumbotron-link-container": true,
      "disabled": this.hasAccount
    };
  }

  setAccountType () {
    if (!this.hasAccount) {
      this.$emit("selected", this.accountType);
    }
  }
}
